module.exports = __webpack_public_path__ + "img/logo--inverse.6dbcb2be.png";